const validaEtapa1 = (values) => {
  if (
    values.questao1 !== '' &&
    values.questao2 !== '' &&
    values.questao3 !== '' &&
    values.questao4 !== ''
  ) {
    return true;
  }
  return false;
};

const validaEtapa2 = (values) => {
  if (
    values.questao5 !== '' &&
    values.questao6 !== '' &&
    values.questao7 !== ''
  ) {
    return true;
  }
  return false;
};

export const validaCheckboxQ5 = (values) => {
  // eslint-disable-next-line no-plusplus
  for (let x = 0; x < 4; x++) {
    const questaoNameCheckbox = `questao5_${x + 1}`;
    if (Number(values[questaoNameCheckbox])) {
      return true;
    }
  }
  return false;
};

export const validaEtapas = (values, activeStep) => {
  if (activeStep === 0) return validaEtapa1(values);
  if (activeStep === 1) return validaEtapa2(values);
  return false;
};
